/**
 * PermissionDenied Component Documentation
 *
 * This component serves as the 403 error page for the Silanga application.
 * It is displayed when a user tries to access a resource or page for which
 * they don't have the necessary permissions.
 *
 * Features:
 * 1. Clear error messaging with status code (403)
 * 2. User-friendly instructions for resolving the issue
 * 3. Responsive layout that works on all screen sizes
 * 4. Centered content for better user experience
 *
 * Usage:
 * This component should be used in route guards or permission checks
 * when a user attempts to access restricted content.
 */

import React from "react";
import { Box, Typography, Container } from "@mui/material";

/**
 * PermissionDenied Component
 *
 * @returns {JSX.Element} The rendered permission denied error page component
 */
const PermissionDenied = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        {/* Large 403 error code display */}
        <Typography
          variant="h1"
          component="h1"
          gutterBottom
          sx={{ fontSize: "8rem", fontWeight: "bold" }}
        >
          403
        </Typography>
        {/* Main error message */}
        <Typography variant="h5" component="h2">
          You do not have permission to access this.
        </Typography>
        {/* Help message for users */}
        <Typography variant="h7">
          Please contact your administrator for access rights.
        </Typography>
      </Box>
    </Container>
  );
};

export default PermissionDenied;
